import { withConfig } from "@/utils/withConfig";
import { SignupToFrontline } from "./SignupToFrontline";
import type { SignupToFrontlineProps } from "./SignupToFrontlineProps";

export * from "./SignupToFrontline";
export * from "./SignupToFrontlineProps";

export const SignupToFrontlineWithConfig = withConfig<SignupToFrontlineProps>(
  SignupToFrontline,
  "sign_up_to_frontline",
);
